var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgOpenBoxSearch = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 5.62402C20.6193 5.62402 19.5 6.74331 19.5 8.12402C19.5 9.50474 20.6193 10.624 22 10.624C23.3807 10.624 24.5 9.50474 24.5 8.12402C24.5 6.74331 23.3807 5.62402 22 5.62402ZM16.5 8.12402C16.5 5.08646 18.9624 2.62402 22 2.62402C25.0376 2.62402 27.5 5.08646 27.5 8.12402C27.5 9.09776 27.247 10.0124 26.803 10.8057L28.0607 12.0634C28.6464 12.6491 28.6464 13.5989 28.0607 14.1847C27.4749 14.7705 26.5251 14.7705 25.9393 14.1847L24.6817 12.9271C23.8884 13.371 22.9737 13.624 22 13.624C18.9624 13.624 16.5 11.1616 16.5 8.12402ZM8 23.4783V34.888C8 35.6456 8.428 36.3381 9.10557 36.6769L23.1056 43.6769C23.6686 43.9584 24.3314 43.9584 24.8944 43.6769L38.8944 36.6769C39.572 36.3381 40 35.6456 40 34.888V23.4783L29.3417 28.8075C27.9884 29.4841 26.3431 29.0471 25.5039 27.7883L24 25.5325L22.4962 27.7883C21.6569 29.0471 20.0116 29.4841 18.6584 28.8075L8 23.4783ZM23.9515 20.1554L8.03125 12.1709L4.05737 18.0845L20.0623 26.1293L23.9515 20.1554ZM23.9515 20.1554L27.9956 26.1293L44.0342 18.1998L39.9817 12.2231L23.9515 20.1554Z",
    fill: "black",
    fillOpacity: 0.3
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOpenBoxSearch);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/open-box-search.57dfe9c128b1ceb4ebc90b08bae5dfd2.svg";